import { ChangeEvent, useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { getReader, getReportTypes } from '../api/reader-api'
import { useQuery } from 'react-query'
import { ReaderResponse } from 'models/ReaderResponse'
import { toast } from 'react-toastify'
import { getJsonDate, getTomorrowDate, getUtcNow } from 'utils/utils'

const minDate = new Date(2023, 0, 1)

const getReaderData = async (
  id?: string
): Promise<ReaderResponse | undefined> => {
  if (!id) {
    throw new Error('Invalid id')
  }

  return getReader(id!)
}

const ReaderDetail = () => {
  const [selectedDate, setSelectedDate] = useState(getUtcNow())
  const { id } = useParams()
  const location = useLocation()

  const {
    isError: readerIsError,
    data: reader,
    error: readerError,
  } = useQuery({
    queryKey: ['reader', id],
    queryFn: () => getReaderData(id),
  })

  const {
    isError: reportTypesIsError,
    data: reportTypes,
    error: reportTypesError,
  } = useQuery({
    queryKey: ['report_types'],
    queryFn: () => getReportTypes(),
  })

  useEffect(() => {
    if (readerIsError && readerError instanceof Error) {
      toast.error(readerError.message)
    }
  }, [readerIsError, readerError])

  useEffect(() => {
    if (reportTypesIsError && reportTypesError instanceof Error) {
      toast.error(reportTypesError.message)
    }
  }, [reportTypesIsError, reportTypesError])

  const changeDateHandler = (changeEvent: ChangeEvent<HTMLInputElement>) => {
    const timestamp = Date.parse(changeEvent.target.value)
    if (!isNaN(timestamp) && timestamp > 0) {
      setSelectedDate(new Date(timestamp))
    }
  }

  const getReportLink = (type: string): string => {
    return `${location.pathname}/report/${type}/${getJsonDate(selectedDate)}`
  }

  const getEventsLink = (): string => {
    return `${location.pathname}/events/${getJsonDate(selectedDate)}`
  }

  return (
    <div className='flex flex-col text-base m-3'>
      <div className='text-2xl'>
        Reader: {reader?.serial} ({reader?.login})
      </div>
      <div className='pt-3'>
        <input
          type='date'
          id='date-input'
          aria-describedby='helper-text-explanation'
          className='bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 '
          defaultValue={getJsonDate(selectedDate)}
          onChange={changeDateHandler}
          min={getJsonDate(minDate)}
          max={getJsonDate(getTomorrowDate())}
          required
        />
      </div>
      {reportTypes?.map((item) => {
        return (
          <div className='pt-2'>
            <Link
              className='text-blue-600 hover:underline'
              to={getReportLink(item.id)}
              target='_blank'
            >
              Report log in TXT ({item.description || item.id})
            </Link>
          </div>
        )
      })}
      <div className='pt-2'>
        <Link
          className='text-blue-600 hover:underline'
          to={getEventsLink()}
          target='_blank'
        >
          Events in CSV
        </Link>
      </div>
    </div>
  )
}

export default ReaderDetail
